export default __webpack_public_path__ + "static/trama-footer-ecfa36a5e51e98d45fd787f371813621.svg";